export default "__VITE_ASSET__D3o19kcX__"